import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkbox-icon",
  "use": "checkbox-icon-usage",
  "viewBox": "0 0 13 10",
  "content": "<symbol viewBox=\"0 0 13 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"checkbox-icon\">\n<path d=\"M4.54175 9.45084L0.166748 5.07584L1.4005 3.84209L4.54175 6.97459L11.183 0.333344L12.4167 1.57584L4.54175 9.45084Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol